angular.module('leftPaneModule')
.controller('LeftPaneStudentController', [
  '$scope', '$rootScope', '$state', 'classroomApi', 'studentApi', 'cancelableResourceManager', 
  'authentication', 'edxReportItemService', 'timeframe',
  function(
    $scope, $rootScope, $state, $classroomApi, $studentApi, $cancelableResourceManager,
    dblAuthentication, edxReportItemService, timeframe) {

  var updateStudentData = function() {
    // Get Student data here - name - description, highlights, etc.
    var promise = $studentApi.getStudentData($scope.item.id, function(studentData) {
      $scope.studentData = studentData;

      // @NOTE: We need to notify the top part of the left pane that the image is ready
      $rootScope.$broadcast('leftPaneImageReady', $scope.studentData.image_url);
    });
    $cancelableResourceManager.add(promise);
  };

  $scope.$watch('studentData.years', function(years) {
    if (years) {
      timeframe.getYearListSubject().onNext(years);
      // deprecated: use timeframe.getYearListSubject
      $rootScope.$broadcast('updateYears', years);
    }
  });

  var initializeData = function(item) {
    $scope.item = item;

    $scope.viewType = dblAuthentication.growthAsFraction()  ? 'fractionMode' : 'percentMode';

    updateStudentData();
  };

  var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(initializeData);

  var initializeItemSettings = function(e, settingsItem) {
    $scope.studentSettings = settingsItem;
  };
  $scope.$on('settingsItemReady', initializeItemSettings);
  $scope.$on('$destroy', function () {
    itemSubscription.dispose();
  });
}]);
